import { useContext } from 'react'
import {
  ActionDependant,
  evaluateTemplateValue,
  GlobalDataContext,
  TemplateContext,
  useEvaluatedAttributes,
} from '@ea-lab/reactive-json'
import { resolveRichTextHtml } from './editable/richTextHtml'

/**
 * Texte riche d'un bloc, rendu tel quel.
 *
 * `tag:` choisit la balise (défaut `div`). Elle existe parce qu'un TITRE dont
 * une partie est mise en évidence a besoin des deux à la fois : le balisage
 * inline (`<em>`, `<strong>`) et le RANG de titre. Aucun autre composant ne
 * sait faire les deux — un `content:` de `type: h2` rend le HTML en TEXTE, et
 * emboîter ce `<div>` dans un `<h2>` produit un plan de titres invalide qu'un
 * lecteur d'écran annonce de travers. La valeur est donc posée directement
 * dans `<h1>`…`<h6>`, sans conteneur de plus.
 *
 * YAML :
 *   - type: BuilderHtmlField
 *     tag: h1
 *     content: ~~.apiData.data.objectData.data.title
 */

export const BuilderHtmlField = ({ props }) => {
  const globalDataContext = useContext(GlobalDataContext)
  const templateContext = useContext(TemplateContext)
  const attributes = useEvaluatedAttributes(props.attributes)

  const evaluated = evaluateTemplateValue({
    valueToEvaluate: props.content,
    globalDataContext,
    templateContext,
  })

  const Tag = props.tag ?? 'div'

  return (
    <ActionDependant {...props}>
      <Tag
        {...attributes}
        dangerouslySetInnerHTML={{ __html: resolveRichTextHtml(evaluated) }}
      />
    </ActionDependant>
  )
}
